import { INotification } from "shared/components/organisms/AppNotification/@types";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { ICreateTicketNotificationMetadataProps } from "../../../@types/createTicketNotificationTypes";
import {
  NotificationTicketGrid,
  TicketCreatedNotificationContainer,
} from "./styles";
import { useCreateTicketNotification } from "./useCreateTicketNotification";

interface ITicketCreatedNotificationProps {
  notification: INotification<ICreateTicketNotificationMetadataProps>;
}

export const TicketCreatedNotification = ({
  notification,
}: ITicketCreatedNotificationProps) => {
  const {
    user,
    transaction,
    notificationResult,
    goToContentButtonText,
    ticket,
    TicketIcon,
  } = useCreateTicketNotification(notification);

  return (
    <TicketCreatedNotificationContainer className={ticket?.type}>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          <Notification.UserPhoto
            photoSrc={user?.photo}
            username={user?.display_name}
          />
        </Notification.IllustrationContainer>

        <Notification.Title.Container>
          <Notification.Title.Text>
            {notificationResult?.contentTitle}
          </Notification.Title.Text>
        </Notification.Title.Container>

        <Notification.Content.TicketContainer>
          <Notification.Title.Text>Motivo</Notification.Title.Text>
          <Notification.Content.Ticket>
            {notificationResult?.ticketReason}
          </Notification.Content.Ticket>

          <Notification.Content.TicketDivider />

          <NotificationTicketGrid>
            <Notification.Title.Text>Valor</Notification.Title.Text>
            <Notification.Title.Text>
              Tipo de solicitação
            </Notification.Title.Text>

            <Notification.Content.Ticket>
              {notificationResult?.ticketValue}
            </Notification.Content.Ticket>
            <Notification.Content.Ticket>
              <TicketIcon /> {notificationResult?.ticketType}
            </Notification.Content.Ticket>
          </NotificationTicketGrid>
        </Notification.Content.TicketContainer>

        {!!transaction?.uuid_order && (
          <a href={notificationResult?.ticketLink}>
            <ConsolePageForm.Button
              id="notification-go-to-ticket"
              variant="light"
            >
              {goToContentButtonText}
            </ConsolePageForm.Button>
          </a>
        )}

        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>

          <Notification.Footer.Dot />

          <Notification.Footer.Text>
            Ticket #{notificationResult?.ticketId}
          </Notification.Footer.Text>
        </Notification.Footer.Container>
      </Notification.Container>
    </TicketCreatedNotificationContainer>
  );
};
